import selectFolderAndRow from './selectFolderAndRow';
import selectRow from './selectRow';
export interface MailRowRouteParameters {
    folderId?: string;
    rowId: string;
}
export default function mailRowRouteHandler(parameters: MailRowRouteParameters): void {
    selectRow(parameters.rowId);
}
export function mailRowFolderRouteHandler(parameters: MailRowRouteParameters): void {
    const { folderId, rowId } = parameters;
    selectFolderAndRow(folderId, rowId);
}
